import { render } from "./MyOk.vue?vue&type=template&id=2f71e6fe"
import script from "./MyOk.vue?vue&type=script&lang=js"
export * from "./MyOk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__